import { Alert, Text } from '@mantine/core'

import { useAuthStore } from '../store/useAuthStore'

export function ImpersonationBanner() {
  const { user } = useAuthStore()

  if (!user?.isImpersonating) {
    return null
  }

  return (
    <Alert
      color="blue"
      variant="filled"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        borderRadius: 0,
      }}
    >
      <Text size="sm" fw={500}>
        Testaustila: Kirjautuneena käyttäjänä {user.firstName}{' '}
        {user.lastName}{' '}
      </Text>
    </Alert>
  )
}
